<template>
    <div id="preloader">
        <div class="canvas">
            <img src="../assets/img/logo.png" alt="logo" class="loader-logo">
            <div class="spinner"></div>
        </div>
    </div>
</template>

<script>
export default {
    name:"Loading",
}
</script>

<style>

</style>